class Resolver {
  name;
  constructor({
    name
  }) {
    this.name = name;
  }
}
export default Resolver;